// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-HPp3m","authorized":"authorized-28fZD","gold":"gold-1eGB8","base":"base-2-R-y","nickel":"nickel-L1XDL"};